import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Switch, Typography } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { useGetDeviceTimelineMutation } from '../../../services/device/deviceService';
import { Header } from '../../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../components/layout/main/mainStyles';
import { ButtonIconStyled } from '../../locations/allLocationsList/allLocationListStyles';
import DataDownloader from '../../../components/timeline/csvDownloader/csvDownloader';
import { ContainerTable } from '../../locations/locationsList/locationListStyles';
import { Timeline } from '../../../components/timeline/timeline';
import Strings from '../../../i18n';

export const TimelineDevicesView = () => {
  const { deviceId, locationId } = useParams();
  const navigate = useNavigate();
  const [showControls, setShowControls] = useState(false);

  const [
    getTimelineByDeviceId,
    { data: timelineData, isSuccess: isSuccessTimelineData }
  ] = useGetDeviceTimelineMutation();

  useEffect(() => {
    getTimelineByDeviceId(deviceId as string);
  }, []);

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-1 col-sm-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-6 col-sm-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.timeline.timelineConnection}
              </StyledTitleHeader>
            </div>
            <div className="col-5 col-sm-4 text-right">
              <div>
                <span>Show Controls</span>
                <Switch
                  checked={showControls}
                  onChange={() => setShowControls(!showControls)}
                />
                {timelineData && (
                  <DataDownloader
                    data={timelineData}
                    selectedId={deviceId as unknown as number}
                  />
                )}
              </div>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <div className="row">
        <div className="col-12">
          <ContainerTable component="main">
            <Typography variant="h6" sx={{ marginLeft: 5, marginTop: 2 }}>
              Timezone: {timelineData?.timeZone}
            </Typography>
            <Timeline
              data={timelineData?.timeline || {}}
              showControls={showControls}
            />
          </ContainerTable>
        </div>
      </div>
    </>
  );
};
